import { render, staticRenderFns } from "./PowerGauge.vue?vue&type=template&id=64957ca8&"
import script from "./PowerGauge.vue?vue&type=script&lang=js&"
export * from "./PowerGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports